'use es6';

import { debounce, isEqual, throttle } from 'underscore';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DropTarget } from 'react-dnd-compat';
import { addModuleToLayoutSectionFromInpageSidebar } from 'InpageEditorUI/eventsAsActions/moduleEventsAsActions';
import { addCustomSectionToDndAreaFromInpageSidebar, addCustomLayoutToDndAreaFromInpageSidebar, addEmbedToDndAreaFromInpageSidebar, addBuildingBlockToGridDndAreaFromInpageSidebar } from 'InpageEditorUI/eventsAsActions/sectionsEventsAsActions';
import { dragTypes, dropTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
import inpageActionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';
import { isResizeHandleType } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
import { isSamePosition } from 'layout-dnd-utils/geometry/basic';
import { getCalculateHoverPositionsCalculator } from 'InpageEditorUI/redux/selectors/hoverPositionConfigSelectors';
import { TOP, BEFORE, AFTER } from 'layout-dnd-utils/js/constants';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import { droppedOnLayoutSection, mouseCoordsAtDropUpdated, layoutSectionColumnsResized, layoutSectionHoverPositionsUpdated, layoutSectionNodePositionsUpdated, layoutSectionDragItemIsHiddenUpdated } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { getNodePositions, getCurrentDropTarget, getBodyOffset as getBodyOffsetSelector, getDragItemIsHidden, getTargetedOrNearbyLayoutSectionId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getLayoutIteratorMap, getGridLayoutIteratorMap } from 'ContentEditorUI/redux/selectors/layoutDataSelectors';
import { getAllLayoutSectionIds, getAllStaticModulesToShowOverlaysOn, getAllFlexColumnModules, getTypeByModuleId, getAllGridLayoutIds, getIsEditingGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
import { convertClientOffsetToPageCoordinates } from 'layout-dnd-utils/scrollHelpers';
import { pixelsToShiftScrollOnDrag } from 'InpageEditorUI/lib/layoutSection/scrollUtils';
import PerformanceStatsGatherer from 'ContentEditorUI/lib/PerformanceStatsGatherer';
import { getDocumentBodyOffset } from 'layout-dnd-utils/dom/offset';
import shallowEqual from 'ContentEditorUI/utils/shallowEqual';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { getGlobalGroupInfo, getGlobalPartialInfo, getHeaderInfo, getBuiltInTypesByModuleId, getBuiltinModuleSchemasById, getFooterInfo } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getCalculateNodePositionsFunc } from 'InpageEditorUI/redux/selectors/nodePositionConfigSelectors';
import { getActiveBreakpointPreviewWidthValue } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getAllModuleSchemasAsArray, getModuleIdsByBuiltinType } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { getPreviewViewportWidth, getPreviewViewportHeight, getPreviewWrapperScrollLeft
// @ts-expect-error not typed yet
} from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { createGridContainer } from 'layout-data-lib/GridLayoutDataTree/layoutBuilderUtils';
const GROWTH_THEME_PATH = '@hubspot/growth';
const ELEVATE_THEME_PATH = '@hubspot/elevate';
const LOGGABLE_SECTION_LABEL_THEME_PATHS = [GROWTH_THEME_PATH, ELEVATE_THEME_PATH];
const mapStateToProps = state => {
  return {
    allLayoutSectionIds: getAllLayoutSectionIds(state),
    allStaticModules: getAllStaticModulesToShowOverlaysOn(state),
    allFlexColumnModules: getAllFlexColumnModules(state),
    currentNodePositions: getNodePositions(state),
    calculateNodePositions: getCalculateNodePositionsFunc(state),
    calculateHoverPositions: getCalculateHoverPositionsCalculator(state),
    currentBodyOffset: getBodyOffsetSelector(state),
    dragItemIsHidden: getDragItemIsHidden(state),
    dropTarget: getCurrentDropTarget(state),
    globalGroups: getGlobalGroupInfo(state),
    globalPartials: getGlobalPartialInfo(state),
    headers: getHeaderInfo(state),
    footers: getFooterInfo(state),
    layoutIteratorMap: getLayoutIteratorMap(state),
    layoutSectionId: getTargetedOrNearbyLayoutSectionId(state),
    allModuleSchemasArray: getAllModuleSchemasAsArray(state),
    moduleIdsByBuiltinType: getModuleIdsByBuiltinType(state),
    builtInTypesByModuleId: getBuiltInTypesByModuleId(state),
    builtInModuleSchemasById: getBuiltinModuleSchemasById(state),
    previewViewportWidth: getPreviewViewportWidth(state),
    previewViewportHeight: getPreviewViewportHeight(state),
    previewWrapperScrollLeft: getPreviewWrapperScrollLeft(state),
    allGridLayoutIds: getAllGridLayoutIds(state),
    gridLayoutIteratorMap: getGridLayoutIteratorMap(state),
    isEditingGridLayouts: getIsEditingGridLayouts(state),
    activeBreakpointPreviewWidthValue: getActiveBreakpointPreviewWidthValue(state)
  };
};
const mapDispatchToProps = dispatch => ({
  dispatchDropAction: dropAction => dispatch(dropAction),
  mouseCoordsAtDropUpdated: bindActionCreators(mouseCoordsAtDropUpdated, dispatch),
  layoutSectionColumnsResized: bindActionCreators(layoutSectionColumnsResized, dispatch),
  layoutSectionHoverPositionsUpdated: bindActionCreators(layoutSectionHoverPositionsUpdated, dispatch),
  layoutSectionNodePositionsUpdated: bindActionCreators(layoutSectionNodePositionsUpdated, dispatch),
  layoutSectionDragItemIsHiddenUpdated: bindActionCreators(layoutSectionDragItemIsHiddenUpdated, dispatch)
});
const getModuleTypeForDragItem = (props, widgetCid) => {
  //doing all of this to get module type

  const {
    builtInTypesByModuleId,
    builtInModuleSchemasById
  } = props;
  const moduleSchema = builtInModuleSchemasById[widgetCid];
  let moduleType = 'custom';
  if (moduleSchema) {
    const moduleId = moduleSchema.moduleId;
    moduleType = getTypeByModuleId(moduleId, builtInTypesByModuleId);
  }
  return moduleType;
};
const getTargetForInsertedSection = dropTarget => getImmutableOrPlain(dropTarget, 'topOrBottomHovered') === TOP ? BEFORE : AFTER;
const dropTargetSpec = {
  drop(props, monitor, component) {
    // If we already dropped, don't rerun this handler
    if (monitor.didDrop()) {
      return;
    }
    const {
      dispatchActionToEventBus,
      dropTarget,
      layoutSectionId
    } = props;
    const dragItem = monitor.getItem();
    const mouseCoordinates = convertClientOffsetToPageCoordinates(monitor.getClientOffset());

    // If we are dragging column resize handles, bail before the layout related logic below
    if (isResizeHandleType(dragItem.type)) {
      dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.COLUMN_RESIZE));
      return;
    }

    // Store the mouse coords at drop so hover container can immediately recalculate hover positions
    props.mouseCoordsAtDropUpdated(mouseCoordinates);
    const {
      contentType,
      dragId,
      isRow,
      originLayoutSectionId,
      widgetCid,
      customSectionId,
      customLayoutKey,
      sectionTree,
      isEmbed,
      sectionName,
      sectionLabel,
      widgetLabel,
      widgetPath,
      isThemeAsset,
      parentId,
      type
    } = dragItem;

    // Just in case the throttled hover isn't caught up
    component.updateHoverPositionsIfNeeded(mouseCoordinates);
    if (component.hoverPositions.length > 0) {
      const droppedInfo = {
        contentType,
        originLayoutSectionId
      };
      if (isRow) {
        droppedInfo.existingRowId = dragId;
      } else {
        droppedInfo.existingColumnId = dragId;
      }
      if (props.isEditingGridLayouts) {
        droppedInfo.existingNodeId = dragId;
        droppedInfo.parentId = parentId;
      }
      const dropAction = droppedOnLayoutSection(droppedInfo, dropTarget, layoutSectionId);
      if (dropAction) {
        // If we have a widgetCid, it means the drag item is a new module from the Inpage Sidebar.
        if (widgetCid) {
          // We have to use dispatchActionToEventBus here because WidgetAddController is
          // handling the reception of this event, and not a Redux action in the parent.
          dispatchActionToEventBus(addModuleToLayoutSectionFromInpageSidebar(Object.assign({
            widgetCid
          }, dropAction)));
          const payload = {
            insertType: dropAction.type,
            moduleType: getModuleTypeForDragItem(props, widgetCid)
          };
          if (isThemeAsset && widgetPath.startsWith(ELEVATE_THEME_PATH)) {
            payload.themePath = ELEVATE_THEME_PATH;
            payload.label = widgetLabel;
          }
          dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADD_MODULE_FROM_SIDEBAR, payload));
        } else if (isEmbed) {
          const targetBeforeOrAfter = getTargetForInsertedSection(dropTarget);
          dispatchActionToEventBus(addEmbedToDndAreaFromInpageSidebar(Object.assign({
            embedId: customSectionId,
            targetBeforeOrAfter,
            embedName: sectionName
          }, dropAction)));
          dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_EMBED_FROM_SIDEBAR, {}));
        } else if (customSectionId) {
          const targetBeforeOrAfter = getTargetForInsertedSection(dropTarget);
          dispatchActionToEventBus(addCustomSectionToDndAreaFromInpageSidebar(Object.assign({
            customSectionId,
            sectionTree,
            targetBeforeOrAfter,
            isEmptyLayoutSection: dropTarget.id === layoutSectionId && dropTarget.type === dropTypes.INSERT_INTO_EMPTY_COLUMN
          }, dropAction)));
          if (dragItem.isMarketerSection) {
            dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_SAVED_SECTION_FROM_SIDEBAR, {}));
          } else {
            const payload = dragItem.themePath && LOGGABLE_SECTION_LABEL_THEME_PATHS.includes(dragItem.themePath) ? {
              label: sectionLabel,
              themePath: dragItem.themePath
            } : {};
            dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_DEVELOPER_SECTION_FROM_SIDEBAR, payload));
          }
        } else if (customLayoutKey) {
          const targetBeforeOrAfter = getTargetForInsertedSection(dropTarget);
          dispatchActionToEventBus(addCustomLayoutToDndAreaFromInpageSidebar(Object.assign({
            customLayoutKey,
            targetBeforeOrAfter
          }, dropAction)));
          dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.ADDED_LAYOUT_FROM_SIDEBAR, {}));
        } else if (type === DRAG_TYPES.ADD_BUILDING_BLOCK) {
          const content = createGridContainer(dragItem.blockType);
          dispatchActionToEventBus(addBuildingBlockToGridDndAreaFromInpageSidebar(Object.assign({}, dropAction, {
            payload: Object.assign({}, dropAction.payload, {
              content
            })
          })));
        } else {
          props.dispatchDropAction(dropAction);
          let draggedItemType;
          if (dragItem.isColumn) {
            draggedItemType = 'column';
          } else if (dragItem.isRow) {
            draggedItemType = 'row';
          } else if (dragItem.isTopMostRow) {
            draggedItemType = 'section';
          } else {
            draggedItemType = 'module';
          }
          dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.DRAGGED_LAYOUT_ITEM, {
            insertType: dropAction.type,
            draggedItemType
          }));
        }
      }
    }
  },
  hover(props, monitor, component) {
    component.throttledHover(monitor);
  }
};
const dropCollect = monitor => {
  return {
    isOver: monitor.isOver(),
    dragItem: monitor.getItem()
  };
};
class LayoutSectionDragLayerContainer extends Component {
  constructor(props) {
    super(props);
    this.getPixelsToShiftScrollOnDrag = mouseCoordinates => {
      // Note: other implementations of `maybeUpdateScrollOnDrag` (specifically
      // email and the editor-dnd-playground) rely on querying the drag-item component
      // DOM for offset positioning. We aren't doing that here because the drag preview icon
      // for items in a Layout Section are always { x: 0, y: 0 } relative to mouse position.
      //
      // Because of this simplicity, we can simply use the mouse position and inpageScrollingEl
      // scrollTop for computing when to scroll-while-dragging.
      //
      // More info here: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/4448#discussion_r580978
      const inpageScrollingEl = window.document.scrollingElement;
      const {
        previewViewportHeight,
        previewViewportWidth,
        // Left to right scroll happens on the preview wrapper and not in the inpage document
        // itself (so it is passed downthrough redux sync and changed by a dispatched bus message/action)
        previewWrapperScrollLeft
      } = this.props;
      if (inpageScrollingEl) {
        return pixelsToShiftScrollOnDrag(mouseCoordinates, previewViewportWidth, previewViewportHeight, previewWrapperScrollLeft,
        // wrapper scrollTop === inpage document scroll top since there are no top/bottom obstructions
        inpageScrollingEl.scrollTop);
      }
      return [0, 0];
    };
    this.maybeUpdateScrollTopOnDrag = mouseCoordinates => {
      const inpageScrollingEl = window.document.scrollingElement;
      const [pixelsToShiftTop] = this.getPixelsToShiftScrollOnDrag(mouseCoordinates);
      if (inpageScrollingEl && pixelsToShiftTop !== 0) {
        inpageScrollingEl.scrollTop = inpageScrollingEl.scrollTop + pixelsToShiftTop;
      }
    };
    this.maybeUpdateScrollLeftOnDrag = mouseCoordinates => {
      const {
        dispatchActionToEventBus
      } = this.props;
      const [__, pixelsToShiftLeft] = this.getPixelsToShiftScrollOnDrag(mouseCoordinates);
      if (pixelsToShiftLeft !== 0) {
        dispatchActionToEventBus({
          type: inpageActionTypes.SCROLL_PREVIEW_LEFT_ACTION,
          message: {
            deltaX: pixelsToShiftLeft
          }
        });
      }
    };
    this.throttledHover = throttle(this.hover.bind(this), 50);
    this.updateHoverPositionsIfNeeded = this.updateHoverPositionsIfNeeded.bind(this);
    this.whenDragOverStopsFiring = debounce(this.handleDragOverStoppedFiring.bind(this), 200);
    this.perfStats = PerformanceStatsGatherer.getSingletonInstance();
    this.throttledMaybeUpdateScrollLeftOnDrag = throttle(this.maybeUpdateScrollLeftOnDrag, 100);
  }
  componentDidMount() {
    const {
      connectDropTarget
    } = this.props;
    const rootElement = document.body;
    rootElement.setAttribute('data-hs-dragdrop', true);
    connectDropTarget(rootElement);
    document.body.addEventListener('dragover', this.handleDragOverEvent.bind(this));
  }
  componentDidUpdate(prevProps) {
    const {
      isOver,
      currentNodePositions,
      isEditingGridLayouts
    } = this.props;
    if (!prevProps.isOver && isOver && !isEditingGridLayouts) {
      // Get a fresh copy of D&D area node positions on drag start if not
      // editing a grid layout to accomodate for drag preview translations
      this.updateNodePositions();
    } else if (prevProps.isOver && !isOver) {
      // Clear out previous caches
      this.previousMouseCoordinates = null;
      this.previousHoverPositions = null;
    } else if (this.previousMouseCoordinates && currentNodePositions !== prevProps.currentNodePositions) {
      // If the structure changed force hover positions to update with the last known mouse coordinates
      this.forceUpdateHoverPositions(this.previousMouseCoordinates);
    }
  }
  handleDragOverEvent() {
    const {
      dragItemIsHidden
    } = this.props;
    // If the drag item is already hidden, immediately show it when we get a dragover
    if (dragItemIsHidden) {
      this.props.layoutSectionDragItemIsHiddenUpdated(false);
    } else {
      // Otherwise, wait until dragover stops firing, which means the drag left the iframe
      this.whenDragOverStopsFiring();
    }
  }
  handleDragOverStoppedFiring() {
    this.props.layoutSectionDragItemIsHiddenUpdated(true);
  }
  hover(monitor) {
    if (!monitor.isOver()) {
      return;
    }
    this.perfStats.incrementCounter('onHover');
    this.perfStats.startCollectingReactMeasurements();
    const mouseCoordinates = convertClientOffsetToPageCoordinates(monitor.getClientOffset());
    if (monitor.getItemType() === dragTypes.RESIZE_HANDLE) {
      this.handleColumnResizeDrag(monitor, mouseCoordinates);
    } else {
      this.maybeUpdateScrollTopOnDrag(mouseCoordinates);
      this.throttledMaybeUpdateScrollLeftOnDrag(mouseCoordinates);
      this.updateHoverPositionsIfNeeded(mouseCoordinates);
    }
    this.perfStats.stopCollectingReactMeasurements();
  }
  forceUpdateHoverPositions(mouseCoordinates) {
    this.previousHoverPositions = null;
    this.updateHoverPositionsIfNeeded(mouseCoordinates);
  }
  updateHoverPositionsIfNeeded(mouseCoordinates) {
    const {
      currentNodePositions
    } = this.props;
    if (!isSamePosition(mouseCoordinates, this.previousMouseCoordinates)) {
      const startCalculateHoverPositions = this.perfStats.now();
      this.hoverPositions = this.props.calculateHoverPositions(currentNodePositions, mouseCoordinates, {
        includeOutsideBuffer: true
      });
      this.perfStats.incrementCounterAndMeasure('calculateHoverPositions', this.perfStats.now() - startCalculateHoverPositions);
      if (!isEqual(this.previousHoverPositions, this.hoverPositions)) {
        this.perfStats.incrementCounter('layoutSectionHoverPositionsUpdated');
        this.props.layoutSectionHoverPositionsUpdated(this.hoverPositions);
      }
    }
    this.previousMouseCoordinates = mouseCoordinates;
    this.previousHoverPositions = this.hoverPositions;
  }
  handleColumnResizeDrag(monitor, mouseCoordinates) {
    const {
      layoutSectionId
    } = this.props;
    const {
      x
    } = mouseCoordinates;
    const {
      leftColumnId,
      rightColumnId,
      resizeSteps
    } = monitor.getItem();
    const {
      tour
    } = this.context;
    const newColumnSizes = resizeSteps.find(step => {
      if (x > step.mouseXPositionToTrigger.min && x < step.mouseXPositionToTrigger.max) {
        return true;
      }
      return false;
    });
    if (newColumnSizes) {
      const leftColumnInfo = {
        id: leftColumnId,
        newWidth: newColumnSizes.leftColumnSizeWouldBe
      };
      const rightColumnInfo = {
        id: rightColumnId,
        newWidth: newColumnSizes.rightColumnSizeWouldBe
      };
      const hasAlreadySentResizeAction = this.previousResizeInfo && shallowEqual(leftColumnInfo, this.previousResizeInfo.leftColumnInfo) && shallowEqual(rightColumnInfo, this.previousResizeInfo.rightColumnInfo);
      if (!hasAlreadySentResizeAction) {
        if (tour && tour.getStep() === 'resizeColumn' && this.previousResizeInfo) {
          tour.next();
        }
        this.props.layoutSectionColumnsResized(layoutSectionId, {
          leftColumnInfo,
          rightColumnInfo
        });
        this.previousResizeInfo = {
          leftColumnInfo,
          rightColumnInfo
        };
      }
    }
  }
  updateNodePositions() {
    const {
      allLayoutSectionIds,
      layoutIteratorMap,
      currentNodePositions,
      currentBodyOffset,
      calculateNodePositions,
      allGridLayoutIds,
      gridLayoutIteratorMap,
      activeBreakpointPreviewWidthValue
    } = this.props;
    const previewWidth = activeBreakpointPreviewWidthValue !== null && activeBreakpointPreviewWidthValue !== void 0 ? activeBreakpointPreviewWidthValue : document.documentElement.clientWidth;

    // Currently, we only need to worry about updating D&D area node positions (and not static
    // modules, flex columns, etc) when a drag starts
    const newNodePositions = calculateNodePositions({
      gridLayoutIds: allGridLayoutIds,
      gridLayoutIteratorMap,
      previewWidth,
      layoutSectionIds: allLayoutSectionIds,
      layoutSectionIteratorMap: layoutIteratorMap
    }, currentNodePositions);
    const newBodyOffset = getDocumentBodyOffset();
    const bodyOffsetChanged = !shallowEqual(currentBodyOffset, newBodyOffset);
    const nodePositionsChanged = currentNodePositions !== newNodePositions;
    if (bodyOffsetChanged || nodePositionsChanged) {
      this.props.layoutSectionNodePositionsUpdated(newNodePositions, getDocumentBodyOffset());
    }
  }
  render() {
    return null;
  }
}
LayoutSectionDragLayerContainer.propTypes = {
  allLayoutSectionIds: PropTypes.array.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  calculateNodePositions: PropTypes.func.isRequired,
  calculateHoverPositions: PropTypes.func.isRequired,
  currentNodePositions: PropTypes.object,
  currentBodyOffset: PropTypes.object,
  isOver: PropTypes.bool.isRequired,
  layoutSectionColumnsResized: PropTypes.func.isRequired,
  layoutSectionHoverPositionsUpdated: PropTypes.func.isRequired,
  layoutSectionId: PropTypes.string,
  layoutSectionNodePositionsUpdated: PropTypes.func.isRequired,
  layoutIteratorMap: PropTypes.object.isRequired,
  layoutSectionDragItemIsHiddenUpdated: PropTypes.func.isRequired,
  dragItemIsHidden: PropTypes.bool.isRequired,
  dispatchActionToEventBus: PropTypes.func.isRequired,
  previewViewportHeight: PropTypes.number,
  previewViewportWidth: PropTypes.number,
  previewWrapperScrollLeft: PropTypes.number
};
LayoutSectionDragLayerContainer.contextType = TourContext;
export default connect(mapStateToProps, mapDispatchToProps)(DropTarget([DRAG_TYPES.ADD_MODULE, dragTypes.EXISTING_ITEM, dragTypes.RESIZE_HANDLE, DRAG_TYPES.CUSTOM_SECTION, DRAG_TYPES.ADD_BUILDING_BLOCK], dropTargetSpec, dropCollect)(LayoutSectionDragLayerContainer));